import React, { Component } from 'react';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import { fr } from 'date-fns/locale';
import { DayPicker } from 'react-day-picker';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import 'react-day-picker/dist/style.css';

const MONTHS = [
  'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
  'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc',
];

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: this.props.startDate,
      displayYear: this.props.startDate
        ? dayjs(this.props.startDate).year()
        : dayjs().year(),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      from: nextProps.startDate,
      displayYear: nextProps.startDate
        ? dayjs(nextProps.startDate).year()
        : dayjs().year(),
    });
  }


  showDatePicker = (value) => {
    this.setState({ showPicker: value });
  }


  handleSelect = (rangeOrDate) => {
    const { handleRange, mode } = this.props;
    let update = { }
    if (mode === 'range') {
      update = {
        from: rangeOrDate?.from || null,
        to: rangeOrDate?.to || null
      };
    } else {
      update = { from: rangeOrDate };
    }
    this.setState(update, () => {
      if (mode === 'range' && handleRange) {
        handleRange(update);
      }
    });
  }

  handleFromDayChange = (from) => {
    this.setState({ from, showPicker: false });
    if (this.props.onChange) {
      this.props.onChange(
        dayjs(from),
        this.props.stateName,
      );
    }
  }

  handleFromKeyPress = (e) => {
    if (e.key === 'Enter'){
      this.props.onChange(dayjs(this.state.from), this.props.stateName);
    }
  }

  handleClickAway = () => {
    this.showDatePicker(false);
  }

  changeYear = (delta) => {
    this.setState((prev) => ({ displayYear: prev.displayYear + delta }));
  }

  handleMonthSelect = (monthIndex) => {
    const date = dayjs()
      .year(this.state.displayYear)
      .month(monthIndex)
      .startOf('month')
      .toDate();
    this.setState({ from: date, showPicker: false });
    if (this.props.onChange) {
      this.props.onChange(dayjs(date), this.props.stateName);
    }
  }

  render() {
    const { from, to, showPicker, displayYear } = this.state;
    const {
      label, before, disabled,
      beforeDate,
      disabledDays,
      mode = 'single',
      dayPickerProps = {},
      withInput,
      monthOnly,
      ...props
    } = this.props;
    const fromInputProps = {
      id: 'from',
      name: 'from',
      label,
      onFocus: () => this.showDatePicker(true),
      onKeyPress: this.handleFromKeyPress,
      zindex: 1000,
      disabled: disabled || false,
      readOnly: disabled || false
    };

    const monthPicker = (
      <Paper elevation={4} sx={{ width: 280, p: 2 }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16,
        }}>
          <IconButton size="small" onClick={() => this.changeYear(-1)}>
            <ChevronLeft />
          </IconButton>
          <Typography variant="subtitle1" fontWeight="medium">
            {displayYear}
          </Typography>
          <IconButton size="small" onClick={() => this.changeYear(1)}>
            <ChevronRight />
          </IconButton>
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 8,
        }}>
          {MONTHS.map((m, i) => (
            <Button
              key={m}
              size="small"
              sx={{
                fontSize: 13,
                fontWeight: 500,
                textTransform: 'none',
                py: 1,
                border: 'none',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.05)',
                },
              }}
              onClick={() => this.handleMonthSelect(i)}
            >
              {m}
            </Button>
          ))}
        </div>
      </Paper>
    );

    const Picker = monthOnly ? monthPicker : <DayPicker
      mode={mode}
      locale={fr}
      showOutsideDays
      selected={from && to ? { from, to } : { from }}
      disabled={
        disabledDays ||
        (before ? { } : { before: beforeDate || new Date() })
      }
      displayMonth={from}
      day={from}
      fixedWeeks
      onSelect={this.handleSelect}
      numberOfMonths={1}
      onDayClick={this.handleFromDayChange}
      modifiersStyles={{
        selected: {
          backgroundColor: '#4A90E2',
          color: '#F0F8FF',
        },
      }}
      {...dayPickerProps}
      {...props}
    />;

    const inputValue = () => {
      if (!from) {
        return '';
      }
      if (monthOnly) {
        return dayjs(from).format('MM/YYYY');
      }
      return dayjs(from).format('DD/MM/YYYY');
    };

    return label || withInput ?
      <ClickAwayListener onClickAway={this.handleClickAway}>
        <div id="overlay-wrapper">
          <TextField
            {...fromInputProps}
            fullWidth
            inputProps={{
              readOnly: true,
            }}
            value={inputValue()}
          />
          {showPicker ?
            <div id="datepickeroverlay">{Picker}</div>
            : ''}
        </div>
      </ClickAwayListener> : Picker;
  }
}

export default DatePicker;
